module.exports = "<div class=\"dbm-alert cursor\" ng-if=\"vm.showList\">\n    <i class=\"dbm dbm-punctuation icon\"></i>\n    <div class=\"counter\">\n        <div ng-if=\"vm.useList\" class=\"text\">{{ vm.alertInfo.list.length }}</div>\n        <div ng-if=\"!vm.useList\" class=\"text\">{{ vm.alertInfo }}</div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/alert/alert.tpl.html
// module id = 1872
// module chunks = 0